export default {
    translation: {
        // Keys are grouped by area, sorted in abc order.
        breadcrumbs: {
            ariaLabel: 'breadcrumb',
        },
        button: {
            cancel: 'Cancel',
            delete: 'Delete',
            deleting: 'Deleting...',
            save: 'Save',
            saving: 'Saving...',
        },
        devicesList: {
            emptyMessageFiltering: 'No devices found.',
            emptyMessageAddNew: 'Add a device to get started.',
            filters: {
                addFiltersButton: 'Add Filters',
                dropdown: 'Filters',
                firmware: 'Firmware Version',
                location: 'Location',
                model: 'Model',
                manufacturer: 'Manufacturer',
                testsStatus: 'Tests Status',
                testsStatusAll: 'All Statuses',
                testsStatusAllPass: 'All tests pass',
                testsStatusHasFailing: 'Has failing tests',
                testsStatusHasUnrun: 'Has unrun tests',
            },
            headers: {
                addNew: 'Add New',
                addNewTooltip: 'Add New Device',
                addedDate: 'Date Added',
                lastRun: 'Last Run',
                passingTests: 'Passing Tests',
            },
            item: {
                editTooltip: 'Edit device information',
                firmware: 'Firmware:',
                itemTooltip: 'View device tests',
                location: 'Location:',
                serial: 'Serial #:',
            },
            title: 'Devices',
        },
        editDevice: {
            deleteModal: {
                body: 'Are you sure you want to delete this device?',
                header: 'Delete Device',
            },
            formNote: `<bold>Note:</bold> Manufacturer, model, and firmware version cannot be changed after creation. If you need to update them, please create a new device instead.`,
            fields: {
                firmware: 'Firmware Version',
                location: 'Location #',
                manufacturer: 'Manufacturer',
                serial: 'Serial #',
                model: 'Model',
                macAddress: 'Mac Address'
            },
            newTitle: 'New Device',
            title: 'Edit Device',
        },
        firmwaresList: {
            emptyMessageFiltering: 'No firmware versions found.',
            emptyMessageAddNew: 'Add a firmware version to get started.',
            headers: {
                addNew: 'Add New',
                addNewTooltip: 'Add New Firmware Version',
                addedDate: 'Date Added',
            },
            title: 'Firmware Versions',
            item: {
                editTooltip: 'Edit firmware information',
                isDeleted: 'Is Deleted:',
                isDeletedAt: 'Is Deleted At:',
            },
        },
        editFirmwareVersion: {
            deleteModal: {
                body: 'Are you sure you want to delete this firmware version?',
                header: 'Delete FirmwareVersion',
            },
            formNote: `<bold>Note:</bold> Manufacturer and firmware version cannot be changed after creation. If you need to update them, please create a new firmware version instead.`,
            fields: {
                firmware: 'Firmware Version',
                manufacturer: 'Manufacturer',
            },
            newTitle: 'New Firmware Version',
            title: 'Edit Firmware Version',
        },
        manufacturersList: {
            emptyMessageFiltering: 'No manufacturers found.',
            emptyMessageAddNew: 'Add a manufacturer to get started.',
            headers: {
                addNew: 'Add New',
                addNewTooltip: 'Add New Manufacturer',
                addedDate: 'Date Added',
            },
            title: 'Manufacturers',
            item: {
                editTooltip: 'Edit manufacturer information',
                isDeleted: 'Is Deleted:',
                isDeletedAt: 'Is Deleted At:',
            },
        },
        editManufacturer: {
            deleteModal: {
                body: 'Are you sure you want to delete this manufacturer?',
                header: 'Delete Manufacturer',
            },
            formNote: `<bold>Note:</bold> You can also update the manufacturer name later.`,
            fields: {
                manufacturer: 'Manufacturer',
            },
            newTitle: 'New Manufacturer',
            title: 'Edit Manufacturer',
        },
        modelsList: {
            emptyMessageFiltering: 'No models found.',
            emptyMessageAddNew: 'Add a model to get started.',
            headers: {
                addNew: 'Add New',
                addNewTooltip: 'Add New Model',
                addedDate: 'Date Added',
            },
            title: 'Models',
            item: {
                editTooltip: 'Edit model information',
                isDeleted: 'Is Deleted:',
                isDeletedAt: 'Is Deleted At:',
            },
        },
        editModel: {
            deleteModal: {
                body: 'Are you sure you want to delete this model?',
                header: 'Delete Model',
            },
            formNote: `<bold>Note:</bold> Manufacturer/Model cannot be changed after creation. If you need to update them, please create a new manufacturer instead.`,
            fields: {
                manufacturer: 'Manufacturer',
                model: 'Model',
            },
            newTitle: 'New Model',
            title: 'Edit Model',
        },
        errors: {
            generic: 'We\'re sorry, an error has occurred: ',
            validation: {
                fallback: 'Validation error: {{errorType}}',
                location: 'Location must be a 5 digit number',
                macAddress: 'Mac address should be in the format "A1:B2:C3:D4:E5:F6"',
                required: 'This field is required',
            }
        },
        filterTag: {
            labels: {
                firmware: 'Firmware Version:',
                location: 'Location:',
                manufacturer: 'Manufacturer:',
                model: 'Model:',
                testsStatus: 'Status:',
            },
            removeButton: 'Remove filter',
        },
        loader: {
            loading: 'Loading...',
        },
        login: {
            header: 'Device Certifier',
            manageAccount: 'Manage Okta Account',
            signInButton: 'Sign In',
        },
        navbar: {
            appName: 'Device Certifier',
            signedInMessage: 'Signed in as:',
            signOut: 'Sign out',
            userName: 'Welcome {{name}}',
            manufacturers: 'Manufacturers',
            models: 'Models',
            firmwareVersions: 'Firmware Versions',
        },
        runGroups: {
            Network: 'Network',
            OAuthFlow: 'OAuth Flow',
            PersistCreds: 'Persist Creds',
            Reregister: 'Re-register',
            RevokeToken: 'Revoke Token',
            MQTTBackoff: 'MQTT Backoff',
            MQTTPersist: 'MQTT Message Persistence',
            MQTTReconnect: 'MQTT Reconnection',
            MessageValidation: 'Message Validation',
        },
        tests: {
            cancelTestsButton: 'Cancel Tests',
            cancelTestsButton_canceling: 'Canceling...',
            events: {
                buttonExpandRequest: 'Request',
                buttonExpandResponse: 'Response',
                mqttConnect: 'MQTT Connect - Device connected.',
                mqttConnectBlocked: 'MQTT Connect - Device attempted to connect and was temporarily blocked.',
                mqttMessage: 'MQTT Message Topic: {{topic}}, Payload: {{payload}}',
                mqttSubscribe: 'MQTT Subscribe Topic: {{topic}}',
                needReboot: 'Waiting on device to reboot...',
                rebootMessage: 'Please restart or turn on your device.',
                responseCode: 'Response: ',
                runStart: 'Starting tests run...',
                runStop: 'Test run finished',
                testFail: 'Test Fail: {{testName}}. Reason: {{failReason}}',
                testGroupStart: 'Test Group Start: {{testGroupName}}',
                testGroupStop: 'Test Group End: {{testGroupName}}',
                testPass: 'Test Pass: {{testName}}',
            },
            
            groupTestsCount: '({{testsCount}} tests)',
            groupStatuses: {
                canceled: '{{cancelCount}} Canceled',
                failed: '{{failCount}} Fail',
                passed: '{{passCount}} Pass',
            },
            headers: {
                selectAll: 'Select All',
            },
            instructions: 'We recommend clearing saved RIOT and Wifi credentials before running tests. '
                + 'However, if saved credentials are detected, the tests will attempt to automatically revoke them.',
            instructionsSDKNote: `Note: there is a known issue where the "Get network creds" and "Persist creds" tests fail to complete when using the Python SDK. `
                + `We apologize for the inconvenience and are working on a fix.`,
            itemStatuses: {
                canceled: 'Canceled',
                failed: 'Error',
                passed: 'Pass!',
                queued: 'Queued',
            },
            runInfo: {
                lastRun: '{{runDate}} at {{runTime}}',
                lastRunLabel: 'Last Run:',
                results: '{{countPass}}/{{countTotal}} Passing',
                resultsLabel: 'Results:',
            },
            runTestsButton: 'Run Tests',
            runTestsButton_starting: 'Starting...',
            runTestsButton_running: 'Running...',
            serverEventsConnecting: 'Connecting to server events...',
            serverEventsError: 'Error connecting to server events.',
            serverEventsNotConnected: 'Not connected to server events.',
            statusCanceled: 'Test was canceled',
            title: 'Run Tests',
        },
    }
}